import {AbstractPage} from "./AbstractPage";
//import {BchdRest} from "./bitcoin-cash/BchdRest";
import {BitcoinCash} from "./bitcoin-cash/BitcoinCash";
import {ChainTools} from "./bitcoin-cash/ChainTools";
import {JqueryApp} from "./JqueryApp";
import {PromptRest} from "./bitcoin-cash/PromptRest";

export class Bridge extends AbstractPage {
    protected bchd: PromptRest;
    protected bitcoinCash: BitcoinCash = null;
    protected chainTools: ChainTools = null;

    constructor(app: JqueryApp) {
        super(app);
        //this.bchd = new PromptRest(this.app.getConfig().bchdRestAddress);
        this.bchd = new PromptRest(this.app.getConfig().apiBase + "/node-api")
        this.chainTools = new ChainTools(this.app.getConfig().apiBase, this.app.getWebHelpers());

        this.app.$(() => { // jQuery 3.0 "document.ready"
            this.initPage();
            this.addEventListeners();
        });
    }

    // ################################################################
    // ###################### PRIVATE FUNCTIONS #######################

    protected initPage() {

    }

    protected addEventListeners() {
        this.app.$(".btnSelectMaxBridgeAmount").on("click", (event) => {
            this.app.$("#amount").val(this.app.getConfig().bridge.maxAmount.toFixed(3)); // TODO max amount per SLP token
        });
    }
}
